function ContextMenuItemSeparator() {
  return (
    <div className="w-full px-3" role="separator" data-testid="ContextMenuItemSeparator">
      <div className="bg-blue100 h-0.5" />
    </div>
  );
}

export default ContextMenuItemSeparator;
